// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../_utils/select-wrapper';
import OptionAccordion from './option-accordion';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  calculateSelectedFinish,
  availableFinishKeys,
  availableFinishOptions,
  finishValue,
} from '../common/finish-and-delivery-options';

const handleFinishChange = (
  deliveryOption,
  value,
  finishesByDeliveryOption,
  onChange,
) => {
  onChange({
    finish: calculateSelectedFinish(
      deliveryOption.key,
      value,
      finishesByDeliveryOption,
    ),
  });
};

const FinishSelector = ({
  deliveryOption,
  finishesByDeliveryOption,
  finishes,
  finish,
  onChange,
  newPrintsBuilderDeliveryAndFinishIcons,
}) => {
  const finishKeys = availableFinishKeys(
    finishesByDeliveryOption,
    deliveryOption,
  );
  const rawOptions = availableFinishOptions(finishes, finishKeys);
  const activeValue = finishValue(finish, finishKeys);

  if (newPrintsBuilderDeliveryAndFinishIcons) {
    const mappedOptions = rawOptions.map((opt) => {
      const fullFin = finishes.find((d) => String(d.key) === String(opt.value));
      return {
        ...opt,
        iconClass: fullFin
          ? `finish-options__${fullFin.name.toLowerCase()}`
          : '',
      };
    });

    return (
      <OptionAccordion
        title="Paper Quality"
        options={mappedOptions}
        value={activeValue}
        onChange={(value) =>
          handleFinishChange(
            deliveryOption,
            value,
            finishesByDeliveryOption,
            onChange,
          )
        }
      />
    );
  };

  return (
    <Select
      label="Paper Quality"
      aria-label="Select Finish"
      value={activeValue}
      options={rawOptions}
      inputStyleLink
      withCaret
      onChange={(value) =>
        handleFinishChange(
          deliveryOption,
          value,
          finishesByDeliveryOption,
          onChange,
        )
      }
    />
  );
};

FinishSelector.propTypes = {
  deliveryOption: DeliveryOption,
  finishesByDeliveryOption: PropTypes.objectOf(PropTypes.arrayOf(PrintFinish)),
  finishes: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish,
  onChange: PropTypes.func,
  newPrintsBuilderDeliveryAndFinishIcons: PropTypes.bool,
}.isRequired;

export default FinishSelector;
